import { Player } from "./player";

export class PlayerEventInfo {
  id: string;

  eventId: string;
  player: Player;
  status: string;
  jersey: string;
  rosterPosition?: number;
  teamAssigned?: boolean;
  teamMemberType: string;
  source: string;

  statusModifiedByPlayerId: string;
	statusModifiedByPlayerEmail: string;
  joinedAt: Date;
	modificationDate: Date;
  invitationSentAt: Date;
  reminderSentAt: Date;

  version : number = 0;

  notificationInProgress : boolean = false;
}

export function hasAssignedTeams(players: PlayerEventInfo[]): boolean {
  // WHITE is the legacy/default jersey; rosterPosition only records ordering.
  // Keep legacy BLACK assignments and explicitly arranged single-colour teams.
  return players.some(p => p.status === 'CONFIRMED' && p.teamMemberType !== 'CANDIDATE' &&
    (p.jersey === 'BLACK' || p.jersey === 'WHITE' && p.teamAssigned === true));
}

export interface GuestParticipationRequest {
  status?: string;
  jersey?: string;
  teamMemberType?: string;
}

export class PlayerEventInfoStatus {
  CONFIRMED : string = "CONFIRMED";
  DECLINED : string = "DECLINED";
  NOT_ANSWERED : string = "NOT_ANSWERED";
  NOT_NOTIFIED : string = "NOT_NOTIFIED";
}

export class PlayerEventInfoJersey {
  WHITE : string = "WHITE";
  BLACK : string = "BLACK";
  YELLOW : string = "YELLOW";
}

export class TeamMemberType {
  FIRST_TEAM: string = "FIRST_TEAM";
  RESERVE: string = "RESERVE";
  CANDIDATE : string = "CANDIDATE";
}

export class PlayerEventInfoSource {
  MANAGER: string = "MANAGER";
  INVITE: string = "INVITE";
}
